/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskPatient } from './taskPatient';
import { TaskPriorityEnum } from './taskPriorityEnum';
import { TaskUser } from './taskUser';
import { TaskAppointment } from './taskAppointment';
import { TaskSubject } from './taskSubject';
import { TaskTeam } from './taskTeam';
import { TaskStatusEnum } from './taskStatusEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface TaskList { 
    readonly id: number;
    readonly subject: TaskSubject;
    title?: string;
    details?: string;
    readonly status: TaskStatusEnum;
    readonly priority: TaskPriorityEnum;
    readonly calculatedPriority: string;
    readonly patient: TaskPatient;
    /**
     * Deep link to where the work actually happens.  The treatment plan lives in TPM\'s patient file. In Creator, the documentation subjects open the Doku tab and everything else lands on Termine; those become internal routes once documentation moves too.
     */
    readonly patientFileUrl: string;
    readonly appointment: TaskAppointment;
    readonly assignedToUser: TaskUser;
    readonly assignedToTeam: TaskTeam;
    dueDate?: string | null;
    readonly completedBy: TaskUser;
    readonly completedAt: string | null;
    readonly createdBy: TaskUser;
    readonly createdAt: string | null;
    readonly updatedAt: string | null;
    creatorTaskId?: string;
    readonly unreadCommentCount: number;
    triggerRef?: string;
}
export namespace TaskList {
}

export const TaskList_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_subject_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_title_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const TaskList_details_Validators: ValidatorFn[] =
    [ ];

export const TaskList_status_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_priority_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_calculatedPriority_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_patient_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_patientFileUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_appointment_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_assignedToUser_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_assignedToTeam_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_dueDate_Validators: ValidatorFn[] =
    [ ];

export const TaskList_completedBy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_completedAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_createdBy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_createdAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_updatedAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_creatorTaskId_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const TaskList_unreadCommentCount_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskList_triggerRef_Validators: ValidatorFn[] =
    [  Validators.maxLength(63),];


